import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/api/query-keys'
import { templatesService } from '@/api/services/templates.service'

export function useTemplateCategoriesQuery() {
  return useQuery({
    queryKey: queryKeys.templates.categories(),
    queryFn: () => templatesService.getTemplateCategories(),
    staleTime: 5 * 60 * 1000,
    retry: false,
    refetchOnWindowFocus: false,
  })
}
